// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__2wxRe","footer":"ModalError_footer__1bXHZ"};